import { useQuery } from 'cccisd-react-query';
import { client } from 'cccisd-apollo';
import studentAssessmentsQuery from './studentAssessments.graphql';
import useSurveyHandles from './useSurveyHandles.js';

const Fortress = window.cccisd.fortress;

const useStudentAssessments = studentPawnId => {
    const { data: surveyHandles } = useSurveyHandles();

    const { data } = useQuery({
        queryKey: ['getProviderStudents', studentPawnId],
        queryFn: async () => {
            const res = await client.query({
                query: studentAssessmentsQuery,
                variables: { studentPawnId, instructorPawnId: Fortress.user.acting.id },
                fetchPolicy: 'network-only',
            });

            const list = res.data.roles.learner.selectedAssignmentPlanList
                .map(item => {
                    return {
                        id: item.assignmentPlanId,
                        archived: Boolean(item.archivedAt),
                        assessedAt: item.createdAt,
                        deploymentIds: [
                            ...item.sessionList.reduce((set, session) => {
                                Object.values(session.sessionDeploymentInfo).forEach(info => {
                                    set.add(info.deploymentId);
                                });
                                return set;
                            }, new Set()),
                        ],
                        pawnDeploymentIds: item.sessionList.reduce((obj, session) => {
                            Object.values(session.sessionDeploymentInfo)
                                .filter(info => info.assigned || !('assigned' in info))
                                .forEach(info => {
                                    obj[info.pawnId] ||= [];
                                    obj[info.pawnId].push(info.deploymentId);
                                });
                            return obj;
                        }, {}),
                        assessments: item.sessionList.reduce((arr, session) => {
                            arr.push(
                                ...session.settings.sessionCollection.map(collection => ({
                                    id: collection.id,
                                    label: collection.label,
                                    reporter: session.settings.reporter,
                                    surveyIds: session.settings.options
                                        .map(handle => surveyHandles[handle])
                                        .filter(Boolean),
                                }))
                            );

                            return arr;
                        }, []),
                    };
                })
                .sort((a, b) => (b.assessedAt > a.assessedAt ? 1 : -1));

            return list;
        },
        enabled: Boolean(studentPawnId && surveyHandles),
    });

    return {
        loading: Boolean(studentPawnId && !data),
        data,
    };
};

export default useStudentAssessments;
